module.exports = __webpack_public_path__ + "img/cmbs-chronicle-sep-13-2021-group.220c723f.jpg";